import React from 'react'

function LabelTopView({label,icon}) {
  return (
    <div>
         <div className="grid grid-cols-1 lg:grid-cols-1 gap-4 mt-4">
              <div className="text-sm sm:text-md  col-span-1 lg:col-span-2 font-semibold text-gray-900 mb-2 flex items-center space-x-4">
                
                <h2 className="uppercase ">{label}</h2>
              </div>
              </div>
    </div>
  )
}

export default LabelTopView